import './assets/css/tailwind.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/css/style.css';
import 'typeface-roboto/index.css';
import {initializeKeycloak, kc} from "./security-keycloak";
import VueTailwind from 'vue-tailwind';
import { TModal, TPagination,} from 'vue-tailwind/dist/components';


const settings = {
    't-modal': {
        component: TModal
    },
    't-pagination': {
        component: TPagination
    }
}

Vue.use(VueTailwind, settings);


initializeKeycloak().then(() => {
    setInterval(async () => {
        try {
            const refreshed = await kc.instance.updateToken(30) // 30s de margem
            if (refreshed) {
                console.info('[Keycloak] Token atualizado com sucesso.')
            }
        } catch (err) {
            console.error('[Keycloak] Falha ao atualizar token:', err)
            kc.logout()
        }
    }, 10000)
    // 🚀 Monta o app após Keycloak estar pronto
    new Vue({
        store,
        router,
        render: h => h(App)
    }).$mount('#app');
}).catch((err) => {
    console.error('[Keycloak] Falha na inicialização:', err)
    kc.logout();
})


